import { BaseModel } from './base.model';

enum UserRole {
  admin = 'admin',
  register = 'register',
  manager = 'manager',
  readonly = 'readonly',
}

type Role = keyof typeof UserRole;
type Roles = Role[];

type UserModel = BaseModel & {
  id: string;
  email: string;
  namePrefix: string;
  name: string;
  permission: string;
  projects: string[];
};

export { UserRole };
export type { Role, Roles, UserModel };
